module.exports = __webpack_public_path__ + "static/media/beep.3a1e1b80.mp3";